export default __webpack_public_path__ + "static/media/thankyou.3eadf921.png";